export default "__VITE_ASSET__Bt$h_MDQ__"